import React, { useState } from "react";
import firebase from "../firebase";
import { Link } from "react-router-dom";
import { Redirect } from "react-router";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Addpost.css";

const Addpost = (props) => {
  const [postTitle, setTitle] = useState("");
  const [postAuthor, setAuthor] = useState("");
  const [postText, setPost] = useState("");
  const [success, addSuccess] = useState("");
  const [error, addError] = useState("");

  const validation = (e) => {
    e.preventDefault();
    if (!postAuthor || !postText || !postTitle) {
      addError("All input fields are required! please give a valid input");
      addSuccess("");
    } else {
      addpost();
    }
  };

  const addpost = () => {
    firebase
      .firestore()
      .collection("blog-post")
      .add({
        title: postTitle,
        author: postAuthor,
        post: postText,
      })
      .then((snapshot) => {
        addSuccess("Grate, post is Successfully created!");
        addError("");
      })
      .catch((err) => {
        console.log("error: while adding post", err);
      });
    setPost("");
    setTitle("");
    setAuthor("");
  };

  if (props.location.state) {
    return (
      <main id="createPost">
        <nav className="navbar navbar-light">
          <div className="navigation container">
            <Link to="/">
              <h3 className="Navbar-brand">BLOGO</h3>
            </Link>
            <p className="email">
              Welcome <span>{props.location.state}</span>
            </p>
          </div>
        </nav>
        <div className="addPost container">
          {success !== "" ? (
            <div className="alert alert-success" role="alert">
              {success}
            </div>
          ) : (
            ""
          )}
          {error !== "" ? (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          ) : (
            ""
          )}
          <form onSubmit={validation}>
            <h1 className="heading">Create A New Post</h1>
            <div className="form-group">
              <label htmlFor="title">Post title</label>
              <input
                className="form-control"
                id="title"
                type="text"
                name="title"
                value={postTitle}
                placeholder="Post title"
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="author">Author </label>
              <input
                className="form-control"
                id="author"
                type="text"
                value={postAuthor}
                name="author"
                placeholder="Enter author name"
                onChange={(e) => setAuthor(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="post">Post Content</label>
              <textarea
                id="post"
                className="form-control"
                name="post"
                value={postText}
                onChange={(e) => setPost(e.target.value)}
                cols="30"
                rows="10"
              ></textarea>
            </div>
            <button className="btn btn-success btn-lg" type="submit">
              Add
            </button>
            <Link to="/">
              <button className="btn btn-info btn-lg" type="button">
                Home
              </button>
            </Link>
          </form>
        </div>
      </main>
    );
  } else {
    return <Redirect to="/" />;
  }
};

export default Addpost;
